module.exports = __webpack_public_path__ + "static/media/rewards-lock.2a6063c3.svg";